<template>
   <div class="ViewScreenLoadingOverlay container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="udpateCloseViewScreenLoadingOverlay($event)">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Name:
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      {{learningLevelNameValue}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Image:
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      <img class="imgWidthHeight img-responsive img-background-color" :src="AssetURLValue">
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Version:
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      {{VersionValue}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Author:
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      {{AuthorValue}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Quote:
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      {{QuoteValue}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Created TS:
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      {{formatAndShowDate(screenLoadingCreatedTSValue)}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-element-overlay-module-title-font-styles col-md-2 col-lg-2 text-align-right padding-right-0Px font-weight-bold">
                  Updated TS:
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left font-size-20px">
                      {{formatAndShowDate(screenLoadingUpdatedTSValue)}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="udpateCloseViewScreenLoadingOverlay($event)">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
    </div> 
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['selectedScreenLoadingObj'],
  name: 'ViewScreenLoadingOverlay',
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      screenLoadingObjToPost: {
        LoadingAssetMetaDataId: '',
        AssetName: '',
        AssetURL: '',
        Version: '',
        Author: '',
        Quote: '',
        CreatedTS: '',
        UpdatedTS: ''
      }
    }
  },
  components: {},
  methods: {
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    setDefaultValues: function () {
      this.screenLoadingObjToPost.LoadingAssetMetaDataId = this.getSelectedScreenLoadingObj.LoadingAssetMetaDataId
      this.screenLoadingObjToPost.AssetName = this.getSelectedScreenLoadingObj.AssetName
      this.screenLoadingObjToPost.AssetURL = this.getSelectedScreenLoadingObj.AssetURL
      this.screenLoadingObjToPost.Version = this.getSelectedScreenLoadingObj.Version
      this.screenLoadingObjToPost.Author = this.getSelectedScreenLoadingObj.Author
      this.screenLoadingObjToPost.Quote = this.getSelectedScreenLoadingObj.Quote
      this.screenLoadingObjToPost.CreatedTS = this.getSelectedScreenLoadingObj.CreatedTS
      this.screenLoadingObjToPost.UpdatedTS = this.getSelectedScreenLoadingObj.UpdatedTS
    },
    udpateCloseViewScreenLoadingOverlay: function (event) {
      var objToReturn = {
        closeOverlay: true,
        updatedObj: null
      }
      this.$emit('closeOverlay', objToReturn)
    }
  },
  computed: {
    learningLevelNameValue: {
      get: function () {
        return this.screenLoadingObjToPost.AssetName
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.AssetName = newValue
      }
    },
    AssetURLValue: {
      get: function () {
        return this.screenLoadingObjToPost.AssetURL
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.AssetURL = newValue
      }
    },
    VersionValue: {
      get: function () {
        return this.screenLoadingObjToPost.Version
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.Version = newValue
      }
    },
    AuthorValue: {
      get: function () {
        return this.screenLoadingObjToPost.Author
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.Author = newValue
      }
    },
    QuoteValue: {
      get: function () {
        return this.screenLoadingObjToPost.Quote
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.Quote = newValue
      }
    },
    screenLoadingCreatedTSValue: {
      get: function () {
        return this.screenLoadingObjToPost.CreatedTS
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.CreatedTS = newValue
      }
    },
    screenLoadingUpdatedTSValue: {
      get: function () {
        return this.screenLoadingObjToPost.UpdatedTS
      },
      set: function (newValue) {
        this.screenLoadingObjToPost.UpdatedTS = newValue
      }
    },
    getSelectedScreenLoadingObj: {
      get: function () {
        return this.selectedScreenLoadingObj
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 3%;
  height: 3%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}

.font-size-20px {
  font-size: 20px;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red {
  border: 1px solid red;
}
.border-white {
    border:1px solid white;
}
.margin-bottom-4point5px {
  margin-bottom:4.5px;
}
.padding-16px-0px {
  padding:16px 0px;
}
.text-vertical-center {
  text-align: center;
}
.border-light-grey {
 border: 1px solid #d6d6d6;   
}
.background-color {
  background-color: #eee;
}
.imgWidthHeight {
  width: 200px;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/screen_loading/ViewScreenLoadingOverlay.vue